import React, { forwardRef } from "react";
import "./Features.css";

const Features = forwardRef((props, ref) => {
  const features = [
    {
      image: "./cards/card1.png",
      title: "Vibrant Play Area",
      description:
        "A colorful and stimulating space for children to safely explore and play creatively and joyfully.",
    },
    {
      image: "./cards/card2.png",
      title: "Dedicated Caregivers",
      description:
        "Caregivers who nurture children with the care and attention of a family member.",
    },
    {
      image: "./cards/card3.png",
      title: "Safe Environment",
      description:
        "A secure setting ensuring your child's safety, with non-toxic toys throughout.",
    },
    {
      image: "./cards/card4.png",
      title: "Emphasis On Hygiene",
      description:
        "High standards of cleanliness and hygiene maintained at all times.",
    },
    {
      image: "./cards/card5.png",
      title: "Air Conditioned",
      description:
        "Comfortable, climate-controlled environment for all seasons.",
    },
    {
      image: "./cards/card6.png",
      title: "Healthy Snacks",
      description:
        "Nutritious snacks provided to support your child's growth and health.",
    },
    {
      image: "./cards/card7.png",
      title: "Transport Available",
      description:
        "Convenient transportation options for easy drop-off and pick-up.",
    },
    {
      image: "./cards/card8.png",
      title: "Annual Memory Book",
      description:
        "Yearly compilation of your child's cherished moments and achievements.",
    },
  ];

  return (
    <section ref={ref} className="features-section">
      <div className="features-container" id="Features">

        <div className="feature-heading">
          <img
            src="./images/strikeline.png"
            alt=""
            id="strikeline"
          />

          <h1>
            <span style={{ color: "black" }}>Agape </span>
            <span style={{ color: "#F55DAF" }}>Features</span>
          </h1>

          <p>
            See what makes Agape Garden Play School special with our unique
            features.
          </p>
        </div>

        <div className="feature-cards">

          {/* Row 1 - Cards 1 to 4 */}
          <div className="row">
            {features.slice(0, 4).map((feature, index) => (
              <div className="card" key={index}>
                <img
                  src={feature.image}
                  alt={feature.title}
                />

                <p>{feature.title}</p>

                <div className="card-text">
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Row 2 - Cards 5 to 8 */}
          <div className="row">
            {features.slice(4, 8).map((feature, index) => (
              <div className="card" key={index}>
                <img
                  src={feature.image}
                  alt={feature.title}
                />

                <p>{feature.title}</p>

                <div className="card-text">
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
});

export default Features;